export enum FilterTypeEnum {
  WorkerAgreementsList = 1,
  WorkersList = 2,
  DeclarationList = 3,
  EmploymentConditionsConfirmationList = 4,
  MandateAgreementWorkedDayList = 5,
  PresencePerDayList = 6,
  PresencePerMonthList = 7,
  HolidayPerMonthList = 8,
  AbsencesPerYearList = 9,
  OrdersList = 10,
  OrdersStartRealizationList = 11,
  LegalizationsList = 12,
  AnnexesList = 13
}
